import {CONIFER_4, GRANITE_7} from '@gaia/colors';
import theme from '@gaia/theme';
import {typographyStyles} from '@map/sidebars/SidebarTypography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
} from '@mui/material';

import UpsellCardButtons from './UpsellCardButtons';

type UpsellFeatureRow = {
    featureName: string;
    isFreeFeature?: boolean;
};

const rows: UpsellFeatureRow[] = [
    {featureName: 'Route Planning Tools', isFreeFeature: true},
    {featureName: 'Record Activities', isFreeFeature: true},
    {featureName: 'Navigate Offline'},
    {featureName: 'Hundreds of Maps'},
    {featureName: 'Precise Weather & Terrain Data'},
    {featureName: 'Create Custom Maps'},
];

export default function PricingCard() {
    const isXtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <div
                style={{
                    height: 480,
                    paddingTop: theme.spacing(2),
                }}
            >
                <TableContainer style={{overflowX: 'hidden'}}>
                    <Table
                        size={isXtraSmallScreen ? 'small' : 'medium'}
                        aria-label='free vs premium features'
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <Typography variant='overline' style={typographyStyles.bold}>
                                        Feature
                                    </Typography>
                                </TableCell>
                                <TableCell align='center'>
                                    <Typography variant='overline' style={typographyStyles.bold}>
                                        Free
                                    </Typography>
                                </TableCell>
                                <TableCell align='center'>
                                    <Typography variant='overline' style={typographyStyles.bold}>
                                        Premium
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, i) => (
                                <TableRow key={i}>
                                    <TableCell component='th' scope='row'>
                                        <Typography variant='h6' component='span'>
                                            {row.featureName}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align='center'>
                                        {row.isFreeFeature && (
                                            <CheckCircleIcon
                                                htmlColor={GRANITE_7}
                                                titleAccess='included'
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell align='center'>
                                        <CheckCircleIcon
                                            htmlColor={CONIFER_4}
                                            titleAccess='included'
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <UpsellCardButtons />
        </>
    );
}
